import React from 'react';
import { useAuth } from '@/contexts/auth';

const AuthDebugInfo = () => {
  const { user, profile, isAdmin, isLoading } = useAuth();
  
  // Only show in development mode
  if (!import.meta.env.DEV) return null;
  
  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0, 0, 0, 0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '4px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px',
      wordBreak: 'break-word'
    }}>
      <strong>Auth Debug Info:</strong><br />
      User ID: {user?.id || 'None'}<br />
      Email: {user?.email || 'None'}<br />
      Profile Loaded: {profile ? 'Yes' : 'No'}<br />
      Is Admin (context): {isAdmin ? 'Yes' : 'No'}<br />
      Is Admin (profile): {profile?.is_admin ? 'Yes' : 'No'}<br />
      Approval Status: {profile?.approval_status || 'Unknown'}<br />
      Loading: {isLoading ? 'Yes' : 'No'}<br />
    </div>
  );
};

export default AuthDebugInfo;